import {
  EMPTY_MEDIA_LABELS_FOR_NEW_SEND,
  WHATSAPP_COLORS,
} from '../constants/whatsapp';

const MEDIA_SIZE = { maxHeight: '190px' };

interface WhatsappPreviewHeaderMediaProps {
  format: string | null;
  mediaUrl?: string | null;
  emptyLabels?: Record<string, string>;
}

export default function WhatsappPreviewHeaderMedia({
  format,
  mediaUrl,
  emptyLabels = EMPTY_MEDIA_LABELS_FOR_NEW_SEND,
}: WhatsappPreviewHeaderMediaProps) {
  const emptyLabel = format ? emptyLabels[format] : undefined;
  if (!emptyLabel) return null;

  if (!mediaUrl) {
    return (
      <div
        className="flex w-full items-center justify-center text-xs"
        style={{
          height: '150px',
          backgroundColor: WHATSAPP_COLORS.placeholder,
          color: WHATSAPP_COLORS.meta,
        }}
      >
        {emptyLabel}
      </div>
    );
  }

  if (format === 'VIDEO') {
    return (
      <video
        src={mediaUrl}
        controls
        muted
        playsInline
        className="w-full object-cover"
        style={MEDIA_SIZE}
      >
        <track kind="captions" />
      </video>
    );
  }

  return (
    <img
      src={mediaUrl}
      alt=""
      className="w-full object-cover"
      style={MEDIA_SIZE}
    />
  );
}
